module.exports = __webpack_public_path__ + "img/buddy_eyes-02.e695681f.svg";